@if (
  {
    row: columnData | async,
  };
  as $
) {
  <p [innerHTML]="getClientStatusHtml($.row.clt_status)"></p>
}
